import { addTransitionType, startTransition } from "react"
import { flushSync } from "react-dom"

export default function startViewTransition(
  callback: () => void,
  onComplete?: () => void,
  types?: string[]
) {
  if (types?.length) {
    startTransition(() => {
      for (const type of types) {
        addTransitionType(type)
      }
      callback()
    })
    return
  }

  if ("startViewTransition" in document) {
    document
      .startViewTransition({
        update: () => {
          flushSync(() => {
            callback()
          })
        },
      })
      .finished.then(() => {
        onComplete?.()
      })
  } else {
    callback()
    onComplete?.()
  }
}
